export default __webpack_public_path__ + "static/media/1.13cc51f6.svg";